import type { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';

// One route (optional param) so a direct/deep link to a specific prayer talk
// still resolves to the same route name as the bare listing — components that
// key off `route.name === AppScreens.PrayerExperience` (main.ts's activeScreen
// detection, this module's own route watcher) need that to hold for both.
export const prayerExperienceRoute: RouteRecordRaw = {
  path: `/prayer-talks/:prayerTalkId?`,
  name: AppScreens.PrayerExperience,
  component: () => import('@/modules/prayer-experience/views/PrayerExperience.vue'),
  props: true,
  meta: {
    layout: 'main',
  },
};
